export function getLogoUrl(data) {
    const { company } = data || {};
    const { logoUploaded, logoPath } = company || {};
    const logoUrl = logoUploaded && logoPath ? `${process.env.CDN_URL}/${logoPath}` : undefined;
    return logoUrl;
}
